module.exports = __webpack_public_path__ + "img/horizontal.fc9316b4.svg";